import claimService from '@rd-web-markets/shared/dist/services/claim/claim.service';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import React, { useState } from 'react';
export function ClaimFinancialField(_ref) {
  let {
    claim,
    setClaim,
    fieldName,
    disabled,
    onClaimUpdateSuccess,
    size = 'sm'
  } = _ref;
  const [stateClaim, setStateClaim] = useState(claim);
  const updateClaim = claimService.useUpdate({
    claimId: claim.id,
    setClaim,
    onSuccess: onClaimUpdateSuccess
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: _ref2 => {
      let {
        target: {
          value
        }
      } = _ref2;
      return setClaim({
        ...claim,
        [fieldName]: value
      });
    },
    onBlur: () => updateClaim({
      ...claim
    }),
    disabled: claim.financials_locked || disabled,
    name: fieldName,
    size: size,
    style: {
      textAlign: 'right'
    },
    object: {
      ...claim,
      claim: {
        ...claim
      }
    }
  }));
}